import { Entity } from '../interfaces/Entity';
import { XdmEntityObject } from '../models';

function getEntityProperty(
  mappings: { [key: string]: string },
  filter: string
) {
  const property = getEntityProperties(mappings).find((p) =>
    p.toLowerCase().includes(filter.toLowerCase())
  );

  if (!property) {
    throw new Error(`Property ${filter} not found in entity property`);
  }

  return property;
}

function getXdmEntityProperty(
  mappings: { [key: string]: string },
  filter: string
) {
  const property = getXdmEntityProperties(mappings).find((p) =>
    p.toLowerCase().includes(filter.toLowerCase())
  );

  if (!property) {
    throw new Error(`Property ${filter} not found in xdm entity property`);
  }

  return property;
}

function getEntityProperties(mappings: { [key: string]: string }) {
  return Object.keys(mappings);
}

function getEntityNameProperty(mappings: { [key: string]: string }) {
  return getEntityProperty(mappings, 'name');
}

function getEntityIdProperty(mappings: { [key: string]: string }) {
  return getEntityProperty(mappings, 'id');
}

function getXdmEntityNameProperty(mappings: { [key: string]: string }) {
  return getXdmEntityProperty(mappings, 'name');
}

function getXdmEntityProperties(mappings: { [key: string]: string }) {
  return Object.values(mappings);
}

function getEntityPropertyName(
  mappings: { [key: string]: string },
  xdmPropertyName: string
) {
  return Object.keys(mappings).find((k) => mappings[k] === xdmPropertyName);
}

function mapFromXdmEntity(
  mappings: { [key: string]: string },
  xdmEntity: XdmEntityObject
): Entity {
  const entityProperties = getEntityProperties(mappings);

  return entityProperties.reduce((acc, curr) => {
    return {
      ...acc,
      [curr]: xdmEntity[mappings[curr]],
    };
  }, {});
}

function getEntityForAllOptionSelected(mappings: { [key: string]: string }) {
  const entityProperties = getEntityProperties(mappings);

  return entityProperties.reduce((acc, curr) => {
    return {
      ...acc,
      [curr]: ALL_OPTION_VALUE,
    };
  }, {});
}

const ALL_OPTION_VALUE = '*';

export {
  ALL_OPTION_VALUE,
  getEntityForAllOptionSelected,
  mapFromXdmEntity,
  getXdmEntityProperties,
  getXdmEntityNameProperty,
  getEntityIdProperty,
  getEntityNameProperty,
  getEntityProperties,
  getEntityPropertyName,
  getEntityProperty,
};
